import { render, staticRenderFns } from "./FullPageTemplate.vue?vue&type=template&id=e6b0c590&scoped=true&"
import script from "./FullPageTemplate.vue?vue&type=script&lang=js&"
export * from "./FullPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FullPageTemplate.vue?vue&type=style&index=0&id=e6b0c590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b0c590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
